import { Component, Input, OnInit } from '@angular/core';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ObjectNames, Severity } from '../../constants/constants';
import { TitleCasePipe } from '@angular/common';
import { LocationFieldsService } from './location-fields.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import data from '../../staticJSON/fieldData.json';
import { LocationService } from '../location.service';
import { AppMainComponent } from 'src/app/app.main.component';

@Component({
  selector: 'app-location-fields',
  templateUrl: './location-fields.component.html',
  styleUrls: ['./location-fields.component.scss']
})
export class LocationFieldsComponent implements OnInit {

  @Input() categories = [];
  @Input() categoryGroup:any;
  fieldForm: FormGroup;
  addEditFieldHeader: string;
  displayAddEditFieldData: boolean = false;
  locationDataTypes = data.locationFieldType;
  fieldDataConstants = ObjectNames.locationConstants;
  locationTypeId;
  locationTypeName;
  invalidData: boolean=false;
  associatedLocations;
  displayLocationAvailability: boolean=false;


  constructor(private confirmationService: ConfirmationService, private titlecasePipe: TitleCasePipe,
    private messageService: MessageService, private fieldService: LocationFieldsService, private fb: FormBuilder,
    private locationService: LocationService,private app: AppMainComponent) { }

  ngOnInit(): void {
    this.locationService.getCategory().subscribe(cat=>{
      if(cat){
        this.showAddCategoryData();
      }
    })
    this.fieldForm = this.fb.group({
      id: [0],
      fieldType: ['', [Validators.required]],
      organizationId: [''],
      name: ['', [Validators.required, Validators.pattern(/^(?!\s*$).+/)]],
      description: [''],
      parentCategoryId: [0],
      groupId: [''],
      group: [null],
      typeId: [''],
      type: [null],
      statusId: [true],
      isValid: [true],
      validFromDate: [''],
      validToDate: [''],
      childCategory: [null],
      createdSource: [''],
      updatedSource: [''],
      createdBy: [''],
      updatedBy: [''],
      createdDate: [''],
      updatedDate: ['']
    });
  }

  getLocationGroup() {
    this.locationService.getAllGroups().subscribe((groups) => {
      const categoryGroup = groups.filter(group => group.name == ObjectNames.locationConstants.categoryGroupName)[0];
      this.getAllLocationCategory(categoryGroup.id);
    })
  }

  getAllLocationCategory(groupId) {
    this.locationService.getAllCategory(groupId).subscribe((category) => {
      this.categories = category;
      this.fieldService.setCategory('');
    })
  }

  checkCategory(cat){
    this.fieldService.getCategoryLocation(cat.id).subscribe((category) => {
     if(category.item1){
       this.deleteCategory(cat);
     }else{
      this.displayLocationAvailability = true;
      this.associatedLocations = category.item2;
     }
    })
  }

  deleteCategory(category) {
    this.confirmationService.confirm({
      message: 'Do you want to delete this Category?',
      header: 'Delete Confirmation',
      icon: 'pi pi-info-circle',
      accept: () => {
        this.fieldService.deleteField(category.id).then(() => {
          this.messageService.add({ severity: Severity.Success, summary: this.titlecasePipe.transform(Severity.Success), detail: 'Deleted Successfully...' });
          const index = this.categories.indexOf(category);
          this.categories.splice(index, 1);
          this.fieldService.setCategory('');
        }).catch(() => {
          this.messageService.add({ severity: Severity.Error, summary: this.titlecasePipe.transform(Severity.Error), detail: 'Error occurred while deleting data...' });
        });
      },
      reject: () => {
      }
    });
  }

  showAddCategoryData(){
    this.fieldForm = this.fb.group({
      id: [0],
      fieldType: ['', [Validators.required]],
      organizationId: [this.app.companyId],
      name: ['', [Validators.required, Validators.pattern(/^(?!\s*$).+/)]],
      description: [''],
      parentCategoryId: [0],
      groupId: [this.categoryGroup.id],
      group: [null],
      typeId: [''],
      type: [null],
      statusId: [true],
      isValid: [true],
      validFromDate: [''],
      validToDate: [''],
      childCategory: [null],
      createdSource: [this.app.userIP],
      updatedSource: [this.app.userIP],
      createdBy: [this.app.userId],
      updatedBy: [this.app.userId],
      createdDate: [new Date().toISOString()],
      updatedDate: [new Date().toISOString()]
    });
    this.addEditFieldHeader = ObjectNames.locationConstants.AddFieldTitle;
    this.displayAddEditFieldData=true;
  }

  showEditCategory(category) {
    this.fieldForm.patchValue(category);
    this.locationTypeId = this.locationDataTypes[0].id;
    this.fieldForm.get('fieldType').setValue(this.locationDataTypes[0]);
    this.locationTypeName = this.locationDataTypes[0].name;
    this.addEditFieldHeader = ObjectNames.locationConstants.EditFieldTitle;
    this.displayAddEditFieldData = true;
  }

  saveField(value){
    if (this.addEditFieldHeader == ObjectNames.locationConstants.AddFieldTitle) {
         const lowerCaseNames = [];
         for (let s of this.categories) {
           lowerCaseNames.push(s.name.toLowerCase().replace(/ /g, ''))
         }
         if (lowerCaseNames.indexOf(value.name.toLowerCase().replace(/ /g, '')) > -1) {
           this.invalidData = true;
         } else {
           delete value['fieldType'];
           this.fieldService.addCategory(value).then(res => {
             this.messageService.add({ severity: Severity.Success, summary: this.titlecasePipe.transform(Severity.Success), detail: 'Added Successfully...' });
             this.getLocationGroup();
             this.displayAddEditFieldData = false;

           });
         }

     } else {
         const duplicateRecord = this.categories.find(depOb => depOb.name.toLowerCase() == value.name.toLowerCase() && depOb.id !== value.id)
         if (duplicateRecord) {
           this.invalidData = true;
         } else {
           this.invalidData = false;
           delete value['fieldType'];
           this.fieldService.updateCategory(value).then(stages => {
             this.messageService.add({ severity: Severity.Success, summary: this.titlecasePipe.transform(Severity.Success), detail: 'Updated Successfully...' });
             this.getLocationGroup();
             this.displayAddEditFieldData = false;
           });
         }

     }
  }

}
